export default {
  title: "Companies overview",
  noRecords: "No companies found",
}
